import Chip from '@mui/material/Chip';
import type { TFormSubmission } from '@onesource/services';
import { FC } from 'react';

const STYLES = {
  inProgress: { label: 'In Progress', bg: '#fff0f3', color: '#ff4d6d' },
  submitted: { label: 'Submitted', bg: '#e8f5e9', color: '#2e7d32' },
  awaitingFeedback: { label: 'Awaiting feedback', bg: '#fff4e5', color: '#b45309' },
  feedbackReady: { label: 'Feedback ready', bg: '#e8f5e9', color: '#2e7d32' },
  rejected: { label: 'Rejected', bg: '#fdecee', color: '#c62828' },
} as const;

/** Where a submission stands. A Hands-On Practice also says whether the teacher's feedback is in. */
export const SubmissionStatusChip: FC<{ submission: TFormSubmission; isTeacherReviewed: boolean }> = ({
  submission,
  isTeacherReviewed,
}) => {
  const style =
    submission.status === 'in_progress'
      ? STYLES.inProgress
      : !isTeacherReviewed
        ? STYLES.submitted
        : submission.rejectedAt
          ? STYLES.rejected
          : submission.feedbackSubmittedAt
            ? STYLES.feedbackReady
            : STYLES.awaitingFeedback;

  return (
    <Chip
      size="small"
      label={style.label}
      sx={{ ml: 1, height: 20, fontSize: '0.7rem', fontWeight: 600, bgcolor: style.bg, color: style.color }}
    />
  );
};
